import { render, staticRenderFns } from "./ListaPrecioFormComponent.vue?vue&type=template&id=05c155ec&"
import script from "./ListaPrecioFormComponent.vue?vue&type=script&lang=js&"
export * from "./ListaPrecioFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports